var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIssue1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6637_43686)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.04353 0.75L16.0792 3.96429V5.03572H15.0078C15.0078 5.1808 14.9506 5.30636 14.8362 5.41239C14.7218 5.51842 14.5865 5.57143 14.4302 5.57143H1.65681C1.50056 5.57143 1.36523 5.51842 1.25084 5.41239C1.13644 5.30636 1.07924 5.1808 1.07924 5.03572H0.0078125V3.96429L8.04353 0.75ZM2.15067 6.10714H4.29353V12.5357H5.36495V6.10714H7.50781V12.5357H8.57924V6.10714H10.7221V12.5357H11.7935V6.10714H13.9364V12.5357H14.4302C14.5865 12.5357 14.7218 12.5887 14.8362 12.6948C14.9506 12.8008 15.0078 12.9263 15.0078 13.0714V13.6071H1.07924V13.0714C1.07924 12.9263 1.13644 12.8008 1.25084 12.6948C1.36523 12.5887 1.50056 12.5357 1.65681 12.5357H2.15067V6.10714ZM15.5017 14.1429C15.6579 14.1429 15.7932 14.1959 15.9076 14.3019C16.022 14.4079 16.0792 14.5335 16.0792 14.6786V15.75H0.0078125V14.6786C0.0078125 14.5335 0.0650112 14.4079 0.179408 14.3019C0.293806 14.1959 0.429129 14.1429 0.585379 14.1429H15.5017Z",
    fill: "#E30000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6637_43686"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.16,
    height: 15,
    fill: "white",
    transform: "matrix(1 0 0 -1 0 15.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIssue1);
export default __webpack_public_path__ + "static/media/issue1.67f44cd11da840033e758198d96a40d0.svg";
export { ForwardRef as ReactComponent };